import type { ReportSchema } from "../types";
import {
    createDateColumn,
    createStringColumn,
    getMetadataValue,
    normalizeStringArray,
} from "./columnHelpers";
import { createLinkColumn } from "./linkColumnHelper";

const namespace = "rds_reports";

export const rdsColumns = [
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.file_name",
        header: "File Name",
    }),
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.document_id",
        header: "Document ID",
    }),
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.Customer Name",
        header: "Customer Name",
    }),
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.Machine Number",
        header: "Machine Number",
        accessor: (row) =>
            normalizeStringArray(
                getMetadataValue(row, "metadata.Machine Number") as string[] | undefined,
            ),
    }),
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.Product Type",
        header: "Product Type",
        accessor: (row) =>
            normalizeStringArray(
                getMetadataValue(row, "metadata.Product Type") as string[] | undefined,
            ),
    }),
    createStringColumn<ReportSchema>({
        namespace,
        field: "metadata.Product Line",
        header: "Product Line",
    }),
    createDateColumn<ReportSchema>({
        namespace,
        field: "metadata.report_period_ini",
        header: "Period Start",
    }),
    createDateColumn<ReportSchema>({
        namespace,
        field: "metadata.report_period_end",
        header: "Period End",
    }),
    createLinkColumn<ReportSchema>({
        namespace,
        field: "metadata.source",
        header: "Source",
    }),
];
